import { useState } from "react";
import { SimpleFormCheck } from "../form/SimpleFormCheck";
import { SimpleFormSelectOption } from "../form/SimpleFormSelect";

export interface IMultiCheckWithSearch {
    checksList: Array<SimpleFormSelectOption>;
    hasSearchBar?: boolean;
    checksName: string;
    styles?: { wrapper?: React.CSSProperties; checkOptions?: React.CSSProperties };
    title: string;
}
const MultiCheckWithSearch = (props: IMultiCheckWithSearch) => {
    const { checksList, checksName, title, hasSearchBar = true, styles = {} } = props;
    const [search, setSreach] = useState("");

    function searchHandler(e: React.ChangeEvent<HTMLInputElement>) {
        const lowerCase = e.target.value.toLowerCase();
        setSreach(lowerCase);
    }

    function filterHandler(): Array<any> {
        const filterValues = checksList.filter((el) => {
            if (search === "") {
                return el;
            } else {
                return el.label.toLowerCase().includes(search);
            }
        });
        return filterValues;
    }
    return (
        <div>
            <label className="form-label">{title}</label>
            <div
                className="p-4 rounded"
                style={{
                    padding: "8px",
                    border: "1px solid var(--kt-input-border-color)",
                    ...styles.wrapper,
                }}
            >
                {hasSearchBar && (
                    <input
                        className="form-control mb-8"
                        value={search}
                        onChange={(e) => searchHandler(e)}
                    />
                )}
                <div
                    style={{
                        paddingTop: "4px",
                        maxHeight: "280px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        whiteSpace: "nowrap",
                        ...styles.checkOptions,
                    }}
                >
                    {filterHandler()?.length != 0 ? (
                        <>
                            {filterHandler().map((register, index) => (
                                <SimpleFormCheck
                                    key={index}
                                    label={register.label}
                                    name={checksName}
                                    value={register.value}
                                />
                            ))}
                        </>
                    ) : (
                        <label className="form-label">None</label>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MultiCheckWithSearch;
